import React, { useState } from 'react';
import { Bell, CheckCircle, AlertCircle, DollarSign, ShoppingBag, Users } from 'lucide-react';
import { useNotification } from '../../context/NotificationContext';

const NotificationBell = () => {
  const [showNotifications, setShowNotifications] = useState(false);
  const { notifications, markAsRead, markAllAsRead, getUnreadCount } = useNotification();
  
  const unreadCount = getUnreadCount();
  
  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  const handleMarkAllRead = () => {
    markAllAsRead();
  };

  const handleMarkRead = (id) => {
    markAsRead(id);
  };

  const getIconClass = (type) => {
    switch (type) {
      case 'price_break':
        return 'bg-green-100 text-green-600';
      case 'group_forming':
        return 'bg-blue-100 text-blue-600';
      case 'tokens_earned':
        return 'bg-yellow-100 text-yellow-600';
      case 'delivery':
        return 'bg-purple-100 text-purple-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };

  const getIconComponent = (type) => {
    switch (type) {
      case 'price_break':
        return DollarSign;
      case 'group_forming':
        return Users;
      case 'tokens_earned':
        return ShoppingBag;
      case 'delivery':
        return CheckCircle;
      default:
        return AlertCircle;
    }
  };

  return (
    <div className="relative">
      <button 
        className="relative p-1"
        onClick={toggleNotifications}
        aria-label="Notifications"
      >
        <Bell size={22} />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
            {unreadCount}
          </span>
        )}
      </button>
      
      {showNotifications && (
        <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg z-50 max-h-96 flex flex-col">
          <div className="border-b px-4 py-2 flex justify-between items-center">
            <h3 className="font-medium">Notifications</h3>
            {unreadCount > 0 && (
              <button 
                className="text-xs text-blue-600"
                onClick={handleMarkAllRead}
              >
                Mark all read
              </button>
            )}
          </div>
          
          <div className="overflow-y-auto flex-1 max-h-72">
            {notifications.length > 0 ? (
              notifications.map((notification) => {
                const IconComponent = getIconComponent(notification.type);
                return (
                  <div 
                    key={notification.id} 
                    className={`px-4 py-3 border-b hover:bg-gray-50 ${notification.read ? '' : 'bg-blue-50'}`}
                    onClick={() => handleMarkRead(notification.id)}
                  >
                    <div className="flex">
                      <div className={`p-2 rounded-full mr-3 ${getIconClass(notification.type)}`}>
                        <IconComponent size={16} />
                      </div>
                      <div className="flex-1">
                        <div className="flex justify-between">
                          <h4 className="font-medium text-sm">{notification.title}</h4>
                          <span className="text-xs text-gray-500">{notification.time}</span>
                        </div>
                        <p className="text-sm text-gray-600 mt-1">{notification.message}</p>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="px-4 py-6 text-center text-gray-500">
                No notifications yet
              </div>
            )}
          </div>
          
          <div className="border-t p-2 text-center">
            <button 
              className="text-sm text-blue-600 w-full py-1 hover:bg-gray-50 rounded"
              onClick={() => setShowNotifications(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;